// Copyright (c) StrangeBee 2023

import { THSecurityTag } from '@Molecules/Inputs/THSecurityTag/THSecurityTag';
import { THForm } from '@Molecules/THForm/THForm';
import { SecurityTagType } from '@Types';
import React, { ReactElement } from 'react';

import './SecurityTagList.scss';

interface SecurityTagListProps {
    hasPermissions: boolean;
    hidden?: ('tlp' | 'pap' | 'severity')[];
}

export const SecurityTagList = ({ hasPermissions, hidden }: SecurityTagListProps): ReactElement => {
    return (
        <div className="security-tag-list">
            {['tlp', 'pap', 'severity']
                .filter((value) => !hidden?.includes(value as SecurityTagType))
                .map((type) => (
                    <THForm.Item key={`form-item-${type}`} name={type}>
                        <THSecurityTag type={type as SecurityTagType} disabled={!hasPermissions} />
                    </THForm.Item>
                ))}
        </div>
    );
};
